import React, { useContext } from 'react';
import { ContentLayout } from 'src/components/ContentLayout';

import { ApiContext } from 'src/context/apiContext';
import { ModelVersionDetails } from 'src/components/ModelVersionDetails';

export const ModelVersionPage = () => {
  const { state } = useContext(ApiContext);

  const currentModelVersionId = state.search.curModelVersionId;
  const modelVersionDetails = state.modelVersions.data.find(
    (mv) => mv['id'] === currentModelVersionId,
  );

  return (
    <ContentLayout
      heading={
        <>
          <h1>{modelVersionDetails?.name}</h1>
        </>
      }
    >
      <ModelVersionDetails />
    </ContentLayout>
  );
};
